module.exports = __webpack_public_path__ + "img/triple.12ee8c6d.svg";